"use strict";

(function () {
  window.addEventListener("message", function (event) {
    var selector = 'iframe';
    var iframes = document.querySelectorAll(selector);
    iframes.forEach(function (iframe) {
      if (iframe.contentWindow === event.source) {
        iframe.style.height = event.data + "px";
        return;
      }
    });
  });
})();